import { INSTANCE_ROUTES } from '@localstack/constants';

export const AppRoute = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  GETTING_STARTED: '/getting-started',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  ONBOARDING: '/onboarding',

  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_AUTHENTICATION: '/settings/authentication',

  SETTINGS_WORKSPACE: '/settings/workspace',
  SETTINGS_MEMBERS: '/settings/members',
  SETTINGS_BILLING: '/settings/billing',

  SETTINGS_SUBSCRIPTION_UPDATE: '/settings/subscriptions/:subscriptionId/update',

  SETTINGS_AUTH_TOKENS: '/settings/auth-tokens',
  SETTINGS_SSO: '/settings/sso',
  SETTINGS_IDENTITY_LOGS: '/settings/identity-logs',
  SETTINGS_USAGE: '/settings/usage',

  PRICING: '/pricing',
  PRICING_SUBSCRIBE: '/pricing/subscribe',
  PRICING_TRIAL_EXPIRED: '/pricing/trial-expired',

  QUICKSTART: '/quickstart',
  QUICKSTARTCLOUDFORMATION: '/quickstart-cloudformation',
  QUICKSTART_DEMO1: '/quickstart/demo1',
  QUICKSTART_DEMO2: '/quickstart/demo2',
  QUICKSTART_DEMO3: '/quickstart/demo3',
  QUICKSTART_DEMO4: '/quickstart/demo4',
  QUICKSTART_DEMO5: '/quickstart/demo5',
  QUICKSTART_SERVERLESS_QUIZ_APP: '/quickstart/serverless-quiz-app',
  QUICKSTART_LOCALSTACK_SWAG_STORE: '/quickstart/localstack-swag-store',

  REDIRECT: '/redirect',

  RECOVER: '/recover',
  RECOVER_ACTIVATE: '/recover/:userId/:key',
  UNSUBSCRIBE_ACTIVATE: '/unsubscribe/:key',
  ACCOUNT_ACTIVATE: '/activate/:key',
  ACCEPT_INVITATION: '/invitation/:token',
  LAUNCHPAD: '/launchpad',

  MARKETPLACE_ACTIVATE: '/auth/marketplace/:token',
  AZURE_MARKETPLACE_ACTIVATE: '/auth/azure-marketplace',
  AUTH_REQUEST_ACTIVATE: '/auth/request/:requestId',
  SSO_CALLBACK: '/auth/sso/callback',
  SSO_START: '/auth/sso/:orgId/:idpName',
  SSO_LOADING: '/auth/sso/loading',

  STUDENT_VERIFICATION: '/student-verification',

  PODS: '/pods',
  PODS_PUBLIC: '/pods/public',
  POD: '/pod/:name',
  POD_DIFF: '/pod/:name/diff',
  POD_LOAD: '/pod/:name/:version/load',

  EXTENSIONS_LIBRARY: '/extensions/library',
  EXTENSIONS_SUBMIT: '/extensions/submit',

  DESKTOP_DOWNLOAD: '/download',

  INSTANCES: '/instances',
  INSTANCES_EPHEMERAL: '/instances/ephemeral',

  ...INSTANCE_ROUTES,

  // admin panel
  ADMIN_HOME: '/admin',
  ADMIN_ACCOUNTS: '/admin/accounts',
  ADMIN_ACCOUNT: '/admin/accounts/:id',
  ADMIN_CREATE_ACCOUNT: '/admin/accounts/new',
  ADMIN_ORGANIZATIONS: '/admin/organizations',
  ADMIN_ORGANIZATION: '/admin/organizations/:id',
  ADMIN_ORGANIZATION_SUBSCRIBE: '/admin/organizations/:orgId/subscribe',
  ADMIN_ORGANIZATION_SUBSCRIPTION: '/admin/organizations/:orgId/subscriptions/:subscriptionId',
  ADMIN_ORGANIZATION_SUBSCRIPTION_UPDATE: '/admin/organizations/:orgId/subscriptions/:subscriptionId/update',
  ADMIN_EXTENSIONS: '/admin/extensions',
  ADMIN_EXTENSION: '/admin/extension/:id',
  ADMIN_ANNOUNCEMENT: '/admin/announcement/new',
  ADMIN_FEATURE_FLAGS: '/admin/feature-flags',
  ADMIN_ADMIN_USERS: '/admin/admin-users',

  // stacks insights
  STACKS_STACK: '/stacks/:stackId',
  STACKS_OVERVIEW: '/stacks',

  NOT_FOUND: '/not-found',

  AUTH_RELAY: '/auth-relay',
};
